import { ROLES } from "../hooks/useRoles";
import { type AppDescription } from "./AppsMenu";

export enum MODULES {
  DASHBOARD = "module_dashboard",
  CONJUNCTIONS = "module_conjunctions",
  CATALOGUE = "module_catalogue",
  ORBITS = "module_orbits",
  UPLOAD = "module_upload",
  PHONEBOOK = "module_phonebook",
  USER_MANAGEMENT = "module_user_management",
  SETTINGS = "module_settings",
}

export const focusOcApps: AppDescription[] = [
  // {
  //   id: "dashboard",
  //   link: "/dashboard",
  //   icon: "dashboard",
  //   text: "Dashboard",
  //   required: [MODULES.DASHBOARD, ROLES.ADMIN],
  // },
  {
    id: "fleet",
    link: "/fleet",
    icon: "heatmap",
    text: "Fleet Status",
    required: [MODULES.CONJUNCTIONS, ROLES.ADMIN],
  },
  {
    id: "conjunctions",
    link: "/conjunctions",
    icon: "intersection",
    text: "Conjunctions",
    required: [MODULES.CONJUNCTIONS, ROLES.ADMIN],
  },
  {
    id: "upload-orbits",
    link: "/orbits",
    icon: "upload",
    text: "Upload orbits",
    required: [MODULES.ORBITS, MODULES.UPLOAD, ROLES.ADMIN, ROLES.UPLOAD],
  },
  {
    id: "catalogue",
    link: "/catalogue",
    icon: "database",
    text: "Catalogue",
    required: [ROLES.ADMIN, ROLES.USER],
  },
  {
    id: "phonebook",
    link: "/phonebook",
    icon: "book",
    text: "Phonebook",
    required: [MODULES.PHONEBOOK, ROLES.ADMIN],
  },
  {
    id: "user-management",
    link: "/user-management",
    icon: "user",
    text: "User Management",
    required: [MODULES.USER_MANAGEMENT, ROLES.ADMIN],
  },
  {
    id: "settings",
    link: "/settings",
    icon: "cog",
    text: "Settings",
    required: [MODULES.SETTINGS, ROLES.ADMIN],
  },
  {
    id: "additional-services",
    link: "/additional-services",
    icon: "shopping-cart",
    text: "Additional Services",
    required: [
      ROLES.ADMIN,
      // ROLES.USER
    ],
  },
];
